/**
 * Admin › Features: every feature with its vote counts, and adding and editing
 * one. No names. Logic lives in `~/lib/server/features`.
 *
 * Aliases: admin features, feature vote counts, roadmap demand, edit feature
 */

import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";

import { permissionMiddleware } from "~/lib/permission-middleware";
import {
  featureCreateSchema,
  featureUpdateSchema,
} from "~/lib/shared/features/schemas";

export const getAdminFeaturesFn = createServerFn({ method: "POST" })
  .middleware([permissionMiddleware("features:read")])
  .handler(async () => {
    const { listFeatures } = await import("~/lib/server/features");
    return listFeatures({ now: new Date() });
  });

export const adminFeaturesQueryOptions = queryOptions({
  queryKey: ["admin-features"] as const,
  queryFn: () => getAdminFeaturesFn(),
});

export const createFeatureFn = createServerFn({ method: "POST" })
  .middleware([permissionMiddleware("features:write")])
  .validator(featureCreateSchema)
  .handler(async ({ data }) => {
    const { createFeature } = await import("~/lib/server/features");
    return createFeature(data);
  });

export const updateFeatureFn = createServerFn({ method: "POST" })
  .middleware([permissionMiddleware("features:write")])
  .validator(featureUpdateSchema)
  .handler(async ({ data }) => {
    const { updateFeature } = await import("~/lib/server/features");
    return updateFeature(data);
  });
